import { createContext, useContext } from 'react'

import type { BookingContinuePolicy } from './types'

export type BookingContinueContextValue = {
  continueBooking: () => Promise<void>
  isContinuing: boolean
}

export type BookingContinueRegistration = {
  owner: BookingContinuePolicy['owner']
  getPolicy: () => BookingContinuePolicy
}

type BookingContinueInternalContextValue = BookingContinueContextValue & {
  registerPolicy: (registration: BookingContinueRegistration) => () => void
}

export const BookingContinueContext = createContext<BookingContinueInternalContextValue | null>(null)

export const useBookingContinue = (): BookingContinueContextValue => {
  const context = useContext(BookingContinueContext)
  if (!context) {
    throw new Error('useBookingContinue must be used within BookingContinueProvider')
  }
  return context
}

export const useBookingContinueInternal = () => {
  const context = useContext(BookingContinueContext)
  if (!context) {
    throw new Error('useBookingContinuePolicy must be used within BookingContinueProvider')
  }
  return context
}
